import styles from './ContactUs.module.sass';
import Button from "@/components/Button/Button";
import Arrow_SVG from "@/components/svg/Global/Arrow_SVG";
import SpeakingHead, {SpeakingHeadStyles} from "@/components/SpeakingHead/SpeakingHead";
import {useGameContext} from "@/context/GameContext";
const ContactUs = () => {
	const {isContactPopupOpen, setIsContactPopupOpen} = useGameContext()

	return (
		<section className={styles.contact_us} id={'contact'}>
			<div className={styles.content}>
				{/*Lawyer Speaking Head */}
				<SpeakingHead parentStyle={styles} speaker={SpeakingHeadStyles.LAWYER}>
					<div className={styles.text}>LE PREMIER RENDEZ-VOUS <br/> EST GRATUIT !</div>
				</SpeakingHead>

				{/*Button*/}
				<div className={styles.button} onClick={() => {
					isContactPopupOpen ? document.body.classList.add('no_scroll') : document.body.classList.remove('no_scroll')
					setIsContactPopupOpen(!isContactPopupOpen)
				}}>
					<Button className={styles.contact_btn}
					        height={'6rem'}
					        borderSize={'2.5px'}
					        gradientPercentage={'85%'}
					        buttonPadding={'1rem'}
					>
						<div className={styles.button_content}>
							<div className={styles.text}>Contact</div>
							<Arrow_SVG className={styles.arrow} color={'#0D422E'}/>
						</div>
					</Button>
				</div>

			</div>

			<div className={styles.bottom}>
				<div className={styles.brown_line}/>
				<div className={styles.light_brown_line}/>
				<div className={styles.dark_line}/>
			</div>
		</section>
	)
}
export default ContactUs